"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _redux = require("redux");
var _reduxThunk = _interopRequireDefault(require("redux-thunk"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _history = _interopRequireDefault(require("./history.js"));
var _connectedReactRouter = require("connected-react-router");
var _boilerplate = _interopRequireDefault(require("./reducers/boilerplate.js"));
var _reduxForm = require("redux-form");
var _store = _interopRequireDefault(require("store"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Boilerplate = window.cccisd.boilerplate;
var pawnId = window.cccisd.fortress.user.pawnId;
var isLoggedIn = !!window.cccisd.fortress.user.user;
var storageKey = isLoggedIn ? "app_".concat(Boilerplate.settings.publicUrl, "_").concat(pawnId) : "app_".concat(Boilerplate.settings.publicUrl);
var storageObject = _store["default"].get(storageKey) || {};

// Enchance reducer to add persist functionality
var persistReducer = function persistReducer(reducer, _ref) {
  var code = _ref.code,
    keys = _ref.keys;
  var initialState = reducer(undefined, {
    type: 'some.undefined.action'
  });
  var persistedState = _objectSpread(_objectSpread({}, initialState), (0, _pick2["default"])(storageObject.redux && storageObject.redux[code], keys));
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : persistedState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var resultedState = reducer(state, action);
    if (resultedState !== state) {
      storageObject.redux = storageObject.redux || {};
      storageObject.redux[code] = (0, _pick2["default"])(resultedState, keys);
      _store["default"].set(storageKey, storageObject);
    }
    return resultedState;
  };
};

// Create store in global area
(function () {
  // Don't create store twice
  if (window.cccisd.store) {
    return;
  }
  function createReducer(asyncReducers, preloadedState) {
    var reducer = (0, _redux.combineReducers)(_objectSpread({
      form: _reduxForm.reducer,
      router: (0, _connectedReactRouter.connectRouter)(_history["default"]),
      boilerplate: _boilerplate["default"]
    }, asyncReducers));
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : preloadedState;
      var action = arguments.length > 1 ? arguments[1] : undefined;
      return reducer(state, action);
    };
  }
  var initialState = window.cccisd && window.cccisd.redux || {};
  var reducer = createReducer();
  var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    shouldHotReload: false
  }) : _redux.compose;
  var middlewares = [_reduxThunk["default"], (0, _connectedReactRouter.routerMiddleware)(_history["default"])];
  var store = (0, _redux.createStore)(reducer, initialState, composeEnhancers(_redux.applyMiddleware.apply(void 0, middlewares)));
  store.asyncReducers = {};
  store.injectReducer = function (name, asyncReducer) {
    // Don't inject the same reducer twice
    if (this.asyncReducers[name]) {
      return console.error("Trying to mount reducer at the \"".concat(name, "\" key twice"));
    }
    this.asyncReducers[name] = asyncReducer;
    this.replaceReducer(createReducer(this.asyncReducers, this.getState()));
  };

  // add store to global
  window.cccisd = window.cccisd || {};
  window.cccisd.store = store;
})();
var _default = function _default(reducers) {
  var store = window.cccisd.store;
  if ((0, _isEmpty2["default"])(reducers)) {
    return store;
  }
  var reducer = (0, _redux.combineReducers)(_objectSpread({}, (0, _mapValues2["default"])(reducers, function (o, code) {
    if (o.persist) {
      return persistReducer(o.reducer, {
        code: "app.".concat(code),
        keys: o.persist.keys || []
      });
    }
    return o.reducer;
  })));
  store.injectReducer('app', reducer);
  return store;
};
exports["default"] = _default;